export const useLogout = () => {  
  const logout = () => {
    localStorage.clear()
    window.location.href = '/login'
  }

  return {
    logout,
  }
}